var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "partial-collapse-container" }, [
    _c(
      "div",
      {
        staticClass: "partial-collapse collapse",
        class: { show: this.isTextExpanded },
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "text-center",
        staticStyle: { display: "block", position: "relative" },
        style: _vm.hidingButtonStyle,
      },
      [
        _c("a", {
          attrs: {
            "data-toggle": "collapse",
            role: "button",
            "aria-expanded": this.isTextExpanded,
          },
          domProps: { textContent: _vm._s(_vm.actionButtonText) },
          on: { click: _vm.onClick },
        }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }